const itemContainer = {
  display: 'flex',
  alignItems: 'center',
};

const itemImage = {
  marginRight: 8,
  flexShrink: 0,
};

const itemText = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};

export const adExtensionItemTemplateStyles = ({ withEllipsisItemText } = {}) => (/* { palette = {},  iconFontFamily = 'MsAds MDL2 Assets' } */) => ({
  // TODO: Needs PM/UX's approval to start using this style in grids
  // Will be used in PMax campaign creation flow
  '& .itemTemplate-text': {
    '& ul, ol': {
      listStyle: 'none',
      paddingLeft: 0,
    },
    ...withEllipsisItemText ? {
      overflowX: 'hidden',
      '& a, div': {
        display: 'block',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    }: {},
  },

  '& .flyerTemplateItemContainer': {
    extend: [itemContainer],
    overflowX: 'hidden',
  },

  '& .flyerTemplateItemImage': {
    extend: [itemImage],
  },

  '& .flyerTemplateItemText': {
    extend: [itemText],
  },

  '& .videoTemplateItemContainer': {
    extend: [itemContainer],
    display: 'flex',
    alignItems: 'center',

    '& .videoTemplateItemTextContainer': {
      overflow: 'hidden',

      '& .videoTemplateItemText': {
        extend: [itemText],
        display: 'block',
        lineHeight: '24px',
      },
    },
  },

  '& .videoTemplateItemImage': {
    extend: [itemImage],
  },

  '& .videoTemplateItemImagePlaceholder': {
    height: 100,
    width: 150,
    minWidth: 150,
    position: 'relative',
    display: 'flex',
  },

  '& .videoTemplateItemImagePlaceholder__background': {
    position: 'absolute',
    left: 45,
    top: 10,

    '& span.iconba.iconba-Video': {
      fontSize: 40,
      color: '#7f7f7f',
      lineHeight: 1,
      margin: '0 0 0 8px',
    },
  },

  '& .videoTemplateItemImagePlaceholder__text': {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: [[0, 20]],
    width: '100%',
    height: '100%',

    '& span': {
      margin: 'auto 4px 12px 0',
      display: 'block',
      lineHeight: 'normal',
      whiteSpace: 'normal',
      textAlign: 'center',
    },
  },
});
